import { CancelToken } from 'axios'
import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'
import { AnalyticOutputLayoutSizeEnum } from '../../../../../enums/analytic-output-layout-size.enum'

export const postTitleOutputService = (
  reportId: string,
  inputId: string,
  titleObject: {
    text: string
    level: number
    layout_size: AnalyticOutputLayoutSizeEnum
  },
  cancelToken?: CancelToken,
) =>
  apiInstance.post(ApiPathConfig.TITLE_OUTPUT(reportId, inputId), titleObject, {
    cancelToken,
  })
